import * as z from "zod";

export const parcelAutomationReferenceSchema = z.object({
  flowId: z.string(),
  flowName: z.string(),
  /** Disabled automations still hold the reference and break once re-enabled. */
  enabled: z.boolean(),
  stepId: z.string(),
  stepName: z.string().optional(),
});

export const getParcelAutomationReferences = {
  name: "getParcelAutomationReferences" as const,
  input: z.object({ parcelId: z.string() }),
  output: z.object({ references: z.array(parcelAutomationReferenceSchema) }),
};
